import React from 'react';
import Typography from '@mui/material/Typography';
import {Card, CardContent} from '@mui/material';
import Button from '@mui/material/Button';
import {Link} from 'react-router-dom';
import classNames from './Welcome.module.css'
import {Layout} from '../components/common/Layout';

export const Welcome = () => {
    return (
        <Layout title="Welcome" showHeader>
            <Card className={classNames.card}>
                <CardContent>
                    <Typography variant="h5">Introduction</Typography>
                    <Typography className={classNames.body} variant="body1">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </Typography>
                    <Button
                        className={classNames.button}
                        component={Link}
                        to="/agreement"
                        variant="contained"
                    >
                        Next
                    </Button>
                </CardContent>
            </Card>
        </Layout>
    )
}
